
import ChooseFile from "./components/ChooseFile"
import "./App.css";

function App() {
  // console.log(currSheet);
  return (
    <div className="App">
      <h1 className="shadow pb-2 mb-2">Analytics Plugin</h1>
      <ChooseFile />
    </div>
  );
}

export default App;
